module.exports = __webpack_public_path__ + "static/media/wall2.0fe2e5de.mp3";